var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleFiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4347 11.6241L10.125 7.24219V11.3428C10.125 11.4174 10.1546 11.4889 10.2074 11.5417C10.2601 11.5944 10.3317 11.6241 10.4062 11.6241H14.4347Z",
    fill: "#C7C9C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 12.5625V6.75H2.8125C2.66332 6.75 2.52024 6.80926 2.41475 6.91475C2.30926 7.02024 2.25 7.16332 2.25 7.3125V22.6875C2.25 22.8367 2.30926 22.9798 2.41475 23.0852C2.52024 23.1907 2.66332 23.25 2.8125 23.25H14.4375C14.5867 23.25 14.7298 23.1907 14.8352 23.0852C14.9407 22.9798 15 22.8367 15 22.6875V13.125H9.1875C9.03832 13.125 8.89524 13.0657 8.78975 12.9602C8.68426 12.8548 8.625 12.7117 8.625 12.5625Z",
    fill: "#C7C9C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1563 5.62406H21.1847L16.875 1.24219V5.34281C16.875 5.4174 16.9046 5.48894 16.9574 5.54169C17.0101 5.59443 17.0817 5.62406 17.1563 5.62406Z",
    fill: "#C7C9C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 7.125C15.7883 7.125 15.6452 7.06574 15.5398 6.96025C15.4343 6.85476 15.375 6.71168 15.375 6.5625V0.75H8.0625C7.91332 0.75 7.77024 0.809263 7.66475 0.914752C7.55926 1.02024 7.5 1.16332 7.5 1.3125V5.25H9.47437C9.72638 5.25101 9.97571 5.3018 10.208 5.39946C10.4403 5.49712 10.6511 5.63971 10.8281 5.81906L15.945 11.0222C16.302 11.3844 16.5013 11.873 16.4995 12.3816V18.75H21.1875C21.3367 18.75 21.4798 18.6907 21.5852 18.5852C21.6907 18.4798 21.75 18.3367 21.75 18.1875V7.125H15.9375Z",
    fill: "#C7C9C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleFiles);
export default __webpack_public_path__ + "static/media/double_files.ea2c23d3.svg";
export { ForwardRef as ReactComponent };